import React, { useContext, useEffect, useState, useRef } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Box, Button, Typography, Skeleton } from '@mui/material';
import { keyframes } from '@mui/system';
// Modals
import ModalDatosContacto from './Modals/ModalDatosContacto.home';
import ModalErrorConsultorioOsde from './Modals/ModalErrorConsultorioOsde.home';
// Constants
import { modales } from '../../utils/Constants/Modales';
import {
  CONSULTORIO_CONNECTION_BLOCKING_COPY,
  resolveConsultorioConnectionBlockingReason
} from '../../utils/Constants/consultorioConnectionBlocking';
//Animation
const animation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
// Icons
import iconWarning from '../../../src/assets/icons/icon_warning.svg';

function NuevaSolicitud({
  loadingVerificacionCD,
  setLoadingVerificacionCD,
  onConsultorioConnectionBlocking,
  consultorioConnectionBlockingReason
}) {
  const [openModals, setOpenModals] = useState(modales);
  const handleClose = () => setOpenModals(modales);

  const { consultoriosContrato, getConsultoriosWithContrato, contratoSeleccionado } = useContext(AgendaContext);

  const verifCdPrimerContrato = useRef(false);

  useEffect(() => {
    const verificarContratoCD = async () => {
      if (!contratoSeleccionado) return;

      try {
        const data = await getConsultoriosWithContrato(contratoSeleccionado);
        const reason = resolveConsultorioConnectionBlockingReason(data?.consultorioDigital);
        onConsultorioConnectionBlocking(reason);
      } finally {
        setLoadingVerificacionCD(false);
        verifCdPrimerContrato.current = true;
      }
    };

    if (contratoSeleccionado && !verifCdPrimerContrato.current) {
      verificarContratoCD();
    }
  }, [contratoSeleccionado]);



  const consultoriosOsdeDisponibles = consultoriosContrato?.consultorioOsde?.some(
    (consultorio) =>
      consultorio.estadoEnInteoperabilidad === 'BAJA' ||
      consultorio.estadoEnInteoperabilidad === null
  );

  const handleOnClick = () => {
    if (consultoriosOsdeDisponibles) {
      setOpenModals({ ...modales, datosContacto: true });
    } else {
      setOpenModals({ ...modales, errorConsultorioOsde: true });
    }
  };

  const theme = useTheme();


  if (loadingVerificacionCD || !contratoSeleccionado) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
        <Skeleton sx={{ marginTop: '-2rem', borderRadius: '1rem' }} variant="text" width={920} height={200} animation="wave" />
      </Box>
    );
  }

  const blockingCopy = consultorioConnectionBlockingReason
    ? CONSULTORIO_CONNECTION_BLOCKING_COPY[consultorioConnectionBlockingReason]
    : null;

  return blockingCopy ? (
    <Box
      sx={{
        width: '100%',
        backgroundColor: theme.palette.alertBackground.main,
        border: `2px solid ${theme.palette.alertSecondary.main}`,
        borderRadius: '1rem',
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        animation: `${animation} 1s `
      }}
    >
      <Box sx={{ display: 'flex', gap: '0.5rem' }}>
        <Box
          component="img"
          sx={{ width: '24px', height: '26px' }}
          alt="img not found"
          src={iconWarning}
        />
        <Typography variant="h3">{blockingCopy.bannerTitle}</Typography>
      </Box>

      <Typography variant="bodyM" sx={{ paddingLeft: '26px' }}>
        {blockingCopy.bannerBody}
      </Typography>
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        height: '7rem',
        width: '100%',
        backgroundColor: theme.palette.backgroundSecondary.main,
        borderRadius: '1rem',
        padding: '2rem',
        gap: '1.5rem',
        justifyContent: 'space-between',
        animation: `${animation} 1s `
      }}
    >
      <Typography variant="h5" sx={{ width: '60%' }}>
        Completá los datos necesarios para que analicemos si tu oferta de turnos presenciales puede
        mostrarse en la cartilla de OSDE.
      </Typography>
      <Button
        onClick={handleOnClick}
        variant="contained"
        sx={{
          width: '40%',
          maxWidth: '308px',
          height: '3rem',
          borderRadius: '1rem'
        }}
      >
        Comenzar
      </Button>
      <ModalDatosContacto openModals={openModals.datosContacto} onHandleClose={handleClose} />
      <ModalErrorConsultorioOsde openModals={openModals.errorConsultorioOsde} onHandleClose={handleClose} />
    </Box>
  );
}

export default NuevaSolicitud;
